import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export default function BasicButtons(props) {

    return (
        <Stack spacing={2} direction="row">
            <Button
                sx={{ color: '#FFCA08', fontSize: 14, fontWeight: 'bolder' }}
                variant="contained"
                fullWidth
                disabled={props.disabled}
                onClick={() => {
                    const onClickFunc = props.onClick
                    onClickFunc()
                }}
            >
                {props.loading ? 'Saving...' : props.text}
            </Button>
        </Stack>
    );
}
